<template>
  <g
    id="Left_Indicator"
    v-on:click="changeSeverity('frontLeftIndicator')"
    :class="severityClass"
  >
    <rect
      class="cls-874"
      x="662.9"
      y="246.32"
      width="9.27"
      height="2.23"
      transform="translate(1335.08 494.87) rotate(180)"
    />
    <g>
      <circle
        class="cls-208"
        cx="675.38"
        cy="247.43"
        r="5.2"
        transform="translate(22.85 550.04) rotate(-45)"
      />
      <circle
        class="cls-458"
        cx="675.38"
        cy="247.43"
        r="5.09"
        transform="translate(22.85 550.04) rotate(-45)"
      />
      <circle class="cls-170" cx="675.38" cy="247.43" r="4.98" />
      <circle class="cls-300" cx="675.38" cy="247.43" r="4.87" />
      <circle class="cls-135" cx="675.38" cy="247.43" r="4.76" />
      <circle class="cls-301" cx="675.38" cy="247.43" r="4.65" />
      <circle class="cls-403" cx="675.38" cy="247.43" r="4.54" />
      <circle class="cls-363" cx="675.38" cy="247.43" r="4.43" />
      <circle class="cls-364" cx="675.38" cy="247.43" r="4.32" />
      <circle class="cls-31" cx="675.38" cy="247.43" r="4.22" />
    </g>
  </g>
</template>

<script>
export default {
  props: {
    severityClass: String
  },
  methods: {
    changeSeverity(section) {
      this.$emit('changeSeverity', section);
    }
  }
};
</script>
